import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../topic/redux/actions';
import { topicFireEngineerImgs } from '../../images/topicImg'

export class StyleTwoQuestionBankList extends Component {
  static propTypes = {
    topic: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    let { Data, onMeiQiaCustomer } = this.props;
    return (
      <div className="topic-style-two-question-bank-list">
        {Data && Data.map(item => <div className='qb_item flex_row' key={item.id}>
          <div className='qb_icon_box flex_row'>{item.icon}</div>
          <div className='qb_content'>
            <div className='qb_content_title'>{item.title}</div>
            <div className='qb_content_tips flex_row'>
              {item.person && <div className='qb_content_person'>{item.person}人参考</div>}
              {item.diff && <div className='qb_content_diff flex_row'>难度{Array.from({ length: item.diff }, (i, k) => ({ id: k + 1, url: topicFireEngineerImgs.question_star })).map(_item => <img src={_item.url} key={_item.id} />)}</div>}
            </div>
          </div>
          <div className='qb_item_btn flex_row' onClick={onMeiQiaCustomer}>开始做题</div>
        </div>)}
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    topic: state.topic,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StyleTwoQuestionBankList);



// WEBPACK FOOTER //
// ./src/features/style-two/StyleTwoQuestionBankList.js